<template>
  <v-list two-line>
    <v-toolbar
      flat
    >
      <!--
      <v-btn
        icon
        to="/eleave/list"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      -->
      <v-toolbar-title>
        {{ $t('eleave.SickForm.Manage' ) }}
      </v-toolbar-title>
    </v-toolbar>
    <v-tabs>
      <v-tab>{{ $t('PublicServant.Me.AL.Processing') }}</v-tab>
      <v-tab>{{ $t('PublicServant.Me.AL.DAFConfirmed') }}</v-tab>
    </v-tabs>

    <div class="px-4">
      <v-row>
        <v-col cols="4">
          <s-search-staff
            :select.sync="searchForm.staffCode"
            :label="$t('PublicServant.Staff')"
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="searchForm.startDate"
            :label="$t('eLeave.StartDate') + ' (YYYY-MM-DD)'"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="searchForm.endDate"
            :label="$t('eLeave.EndDate') + ' (YYYY-MM-DD)'"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="2">
          <v-btn
            fab
            icon
            @click="search"
          >
            <v-icon>{{ mdiMagnify }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-divider />

    <v-list-item to="/eleaveAdmin/StaffSickDetail">
      <v-list-item-content>
        <v-list-item-title>
          陳大文
        </v-list-item-title>
        <v-list-item-subtitle>
          <span class="text--primary">2019-08-29 ~ 2019-08-30</span> - 須留在家中休息
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>15min</v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>黃一二</v-list-item-title>
        <v-list-item-subtitle>
          <span class="text--primary">2019-08-29 ~ 2019-08-30</span> - 須留在家中休息 (親屬)
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>15min</v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>李魚</v-list-item-title>
        <v-list-item-subtitle>
          <span class="text--primary">2019-08-29 ~ 2019-08-29</span> - 須留院治療 (因親屬)
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>15min</v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>

import SSearchStaff from '../../components/SSearchStaff'
import { dateToYyyyMmDd } from '@/utils/datetimeUtil'
import { mdiMagnify } from '@mdi/js'

export default {
  components: {
    SSearchStaff
  },
  data: function () {
    return {
      mdiMagnify: mdiMagnify,
      searchForm: {
        staffCode: null,
        startDate: initStartDate(),
        endDate: initEndDate()
      }
    }
  },
  methods: {
    search: function () {
      console.log(this.staffCode, this.startDate, this.endDate)
    }
  }
}

function initStartDate () {
  let date = new Date()
  date.setDate(date.getDate() - 7)
  return dateToYyyyMmDd(date)
}

function initEndDate () {
  return dateToYyyyMmDd(new Date())
}

</script>
